import { IdentityProvider } from "shared-core/types/organization.ts";
import { SystemId } from "shared-core/types/system.ts";

export type IntegrationName =
  "Google Workspace" | "Meta" | "Microsoft 365" | "WordPress";
export const integrationNames: IntegrationName[] = [
  "Google Workspace",
  "Meta",
  "Microsoft 365",
  "WordPress",
];

export const INTEGRATION_SYSTEM_NAMES: ReadonlyArray<
  readonly [SystemId, IntegrationName]
> = [
  [SystemId.GOOGLE_WORKSPACE, "Google Workspace"],
  [SystemId.META_BUSINESS_SUITE, "Meta"],
  [SystemId.MICROSOFT_365, "Microsoft 365"],
  [SystemId.WORDPRESS, "WordPress"],
];

export function getIntegrationNameByIdentityProvider(
  identityProvider: IdentityProvider,
): IntegrationName | null {
  switch (identityProvider) {
    case IdentityProvider.GOOGLE:
      return "Google Workspace";
    case IdentityProvider.MICROSOFT:
      return "Microsoft 365";
  }

  return null;
}

export enum IntegrationStatusEnum {
  AVAILABLE = "available",
  CONNECTED = "connected",
  INVALID_TOKEN = "invalid_token",
  COMING_SOON = "coming_soon",
  PERMISSION_MISSING = "permission_missing",
}

type IntegrationSecurityChecks = {
  name: string;
  description: string;
  enabled: boolean;
};

export interface IntegrationStatus {
  status: IntegrationStatusEnum;
  lastScan: Date | null;
  connectedSince: Date | null;
  securityChecks: IntegrationSecurityChecks[];
}

export interface IntegrationStatusResponse extends IntegrationStatus {
  id: SystemId;
}

export interface GoogleSignInResponse {
  authUrl: string;
}

export interface CheckEmailResponse {
  authUrl: string;
}

export interface GetOrGenerateApiKeyResponse {
  apiKey: string;
}
